/**
 * Configuração do app, validada na inicialização.
 *
 * Mesmo princípio do `config.py` do back: falhar no boot por variável
 * ausente é preferível a descobrir no primeiro request.
 */
import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.string().default(''),
  VITE_KEYCLOAK_URL: z.url().default('http://localhost:8081'),
  VITE_KEYCLOAK_REALM: z.string().min(1).default('centralone'),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1).default('centralone-spa'),
  /** Portal dos alunos — para "ver como o aluno vê". */
  VITE_PORTAL_URL: z.string().default('http://localhost:5180'),
});

const env = schema.parse(import.meta.env);

export const config = {
  apiUrl: env.VITE_API_URL.replace(/\/$/, ''),
  apiPrefix: '/v1',
  keycloak: {
    url: env.VITE_KEYCLOAK_URL.replace(/\/$/, ''),
    realm: env.VITE_KEYCLOAK_REALM,
    clientId: env.VITE_KEYCLOAK_CLIENT_ID,
  },
  portalUrl: env.VITE_PORTAL_URL.replace(/\/$/, ''),
  isDev: import.meta.env.DEV,
} as const;
